/**
 * Кнопки входа через провайдеров на страницах входа и регистрации.
 *
 * Показываются только те провайдеры, что настроены на сервере: кнопка без
 * ключей вела бы на страницу ошибки (docs/adr/0008-federated-login.md).
 */

import { useOAuthLogin, useOAuthProviders } from '@/api/oauth'
import { strings } from '@/lib/strings'

import { authErrorMessage } from './errorMessage'
import { providerName } from './providerName'

interface OAuthButtonsProps {
  /** Куда вернуть пользователя после входа. */
  next?: string
}

export function OAuthButtons({ next }: OAuthButtonsProps) {
  const providers = useOAuthProviders()
  const login = useOAuthLogin(next)

  // Пока список не пришёл или пуст — не показываем ничего: мигающий блок
  // над формой хуже его отсутствия.
  if (providers.data === undefined || providers.data.length === 0) return null

  return (
    <div className="mt-6 flex flex-col gap-3">
      <div className="flex flex-col gap-2">
        {providers.data.map((provider) => (
          <button
            key={provider}
            type="button"
            disabled={login.isPending}
            onClick={() => {
              login.mutate(provider)
            }}
            className="rounded-lg border border-border px-4 py-2.5 font-medium disabled:opacity-60"
          >
            {strings.auth.continueWith(providerName(provider))}
          </button>
        ))}
      </div>

      {login.error !== null && (
        <p role="alert" className="rounded-lg border border-warning/50 p-3 text-sm text-warning">
          {authErrorMessage(login.error)}
        </p>
      )}

      <p className="text-center text-xs text-muted">{strings.auth.orDivider}</p>
    </div>
  )
}
